import MapPlaceAutocompleteFilter from './PlaceAutocompleteFilter'

export default function CountyFilter({
  filterCounty,
  filterState,
  updateFilter,
}: {
  filterCounty: string[]
  filterState: string[]
  updateFilter: (updates: Record<string, any>) => void
}) {
  return (
    <MapPlaceAutocompleteFilter
      label="County"
      searchType="county"
      placeholder="Search counties..."
      selectedValues={filterCounty}
      allowedStates={filterState}
      filterKey="counties"
      updateFilter={updateFilter}
    />
  )
}
